(function () {
  var VERSION = "1.0.0";

  if (window.VidaLabsHealthProof && window.VidaLabsHealthProof.version === VERSION) {
    window.VidaLabsHealthProof.scan();
    return;
  }

  var sourceCache = new Map();

  function text(value, fallback) {
    if (value === null || value === undefined) return fallback || "";
    return String(value).trim() || fallback || "";
  }

  function escapeHtml(value) {
    return text(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function normalizeUrl(value) {
    var url = text(value);
    if (!url) return "";
    if (/^(https?:|mailto:|tel:)/i.test(url)) return url;
    return "";
  }

  function getField(item, names, fallback) {
    for (var i = 0; i < names.length; i += 1) {
      if (item && item[names[i]] !== undefined && item[names[i]] !== null && text(item[names[i]])) {
        return item[names[i]];
      }
    }
    return fallback || "";
  }

  function normalizePeople(payload) {
    var list = Array.isArray(payload)
      ? payload
      : payload && (payload.profesionales || payload.doctores || payload.people || payload.items || payload.data);

    if (!Array.isArray(list)) return [];

    return list
      .map(function (item) {
        var productHandles = getField(item, ["product_handles", "products", "productos", "handles", "productos_validados"], []);
        if (typeof productHandles === "string") {
          productHandles = productHandles.split(",").map(function (handle) {
            return handle.trim();
          });
        }
        if (!Array.isArray(productHandles)) productHandles = [];

        return {
          name: text(getField(item, ["nombre", "name", "full_name", "nombre_completo"])),
          specialty: text(getField(item, ["especialidad", "specialty", "area", "titulo"])),
          license: text(getField(item, ["cedula", "cedula_profesional", "license", "professional_license"])),
          photo: normalizeUrl(getField(item, ["foto", "photo", "image", "avatar", "imagen"])),
          contact: normalizeUrl(getField(item, ["contacto", "contact", "link", "url", "perfil"])),
          badge: text(getField(item, ["badge", "tipo", "role", "rol"], "Comite")),
          quote: text(getField(item, ["quote", "frase", "comentario", "review"])),
          validation: text(getField(item, ["validacion", "validation", "resumen_validacion", "summary"])),
          coa: normalizeUrl(getField(item, ["coa", "coa_url", "certificado", "certificate_url"])),
          productHandles: productHandles.map(slugify).filter(Boolean)
        };
      })
      .filter(function (person) {
        return person.name;
      });
  }

  function slugify(value) {
    return text(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function initials(name) {
    return text(name)
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) {
        return part.charAt(0).toUpperCase();
      })
      .join("") || "VL";
  }

  function randomSort(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var randomValue = window.crypto && window.crypto.getRandomValues
        ? window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296
        : Math.random();
      var j = Math.floor(randomValue * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function productMatches(person, handle) {
    if (!handle || !person.productHandles.length) return false;
    return person.productHandles.indexOf(slugify(handle)) > -1;
  }

  function pickPeople(people, count, productHandle) {
    var specific = people.filter(function (person) {
      return productMatches(person, productHandle);
    });
    var pool = specific.length ? specific : people;
    return randomSort(pool).slice(0, Math.max(1, count || 1));
  }

  function loadPeople(source) {
    if (!source) return Promise.resolve([]);
    if (!sourceCache.has(source)) {
      sourceCache.set(source, fetch(source, { credentials: "omit" })
        .then(function (response) {
          if (!response.ok) throw new Error("No se pudo cargar el registro de profesionales.");
          return response.json();
        })
        .then(normalizePeople));
    }
    return sourceCache.get(source);
  }

  function avatar(person, sizeClass) {
    var label = escapeHtml(person.name);
    var content = person.photo
      ? '<img src="' + escapeHtml(person.photo) + '" alt="' + label + '" loading="lazy">'
      : "<span>" + escapeHtml(initials(person.name)) + "</span>";
    return '<span class="vl-proof-avatar ' + (sizeClass || "") + '" title="' + label + '">' + content + "</span>";
  }

  function profileCard(person, options) {
    options = options || {};
    var note = person.validation || options.note || "Integra el comite de profesionales que respalda el enfoque cientifico y responsable de VidaLabs.";
    var contact = person.contact
      ? '<a class="vl-proof-card__link" href="' + escapeHtml(person.contact) + '" target="_blank" rel="noopener">Ver contacto</a>'
      : "";
    var coa = person.coa
      ? '<a class="vl-proof-card__link" href="' + escapeHtml(person.coa) + '" target="_blank" rel="noopener">Ver certificado</a>'
      : "";

    return [
      '<article class="vl-proof-card">',
      '  <div class="vl-proof-card__head">',
      avatar(person),
      '    <div>',
      '      <h3 class="vl-proof-card__name">' + escapeHtml(person.name) + '</h3>',
      '      <p class="vl-proof-card__specialty">' + escapeHtml(person.specialty || "Profesional de la salud") + '</p>',
      person.license ? '      <p class="vl-proof-card__license">Ced. ' + escapeHtml(person.license) + '</p>' : "",
      "    </div>",
      "  </div>",
      person.badge ? '  <span class="vl-proof-card__badge">' + escapeHtml(person.badge) + '</span>' : "",
      '  <p class="vl-proof-card__note">' + escapeHtml(note) + '</p>',
      contact || coa ? "  " + contact + coa : "",
      "</article>"
    ].join("");
  }

  function renderHome(root, people) {
    var count = Number(root.dataset.count || 3);
    var selected = pickPeople(people, count, root.dataset.productHandle);
    var grid = root.querySelector("[data-vl-proof-grid]");
    var avatars = root.querySelector("[data-vl-proof-avatars]");
    var total = root.querySelector("[data-vl-proof-count]");

    if (total) total.textContent = people.length || selected.length;
    if (grid) grid.innerHTML = selected.map(function (person) {
      return profileCard(person);
    }).join("");
    if (avatars) {
      avatars.innerHTML = selected.map(function (person) {
        return avatar(person);
      }).join("") + '<span class="vl-proof__avatar-stack-text">Comite activo<br>de profesionales</span>';
    }
  }

  function renderProduct(root, people) {
    var handle = root.dataset.productHandle || "";
    var title = root.dataset.productTitle || "esta formula";
    var selected = pickPeople(people, 1, handle);
    var person = selected[0];
    var featured = root.querySelector("[data-vl-proof-featured]");
    var name = root.querySelector("[data-vl-proof-name]");
    var hasSpecificMatch = productMatches(person, handle);
    var copy = root.querySelector("[data-vl-proof-product-copy]");

    if (name) name.textContent = person.name;
    if (copy) {
      copy.textContent = hasSpecificMatch
        ? title + " fue validado por " + person.name + ". Reviso ingredientes, dosis y forma quimica."
        : title + " forma parte de una linea revisada por el comite de profesionales de la salud. Hoy te presentamos a " + person.name + ".";
    }
    if (featured) {
      featured.innerHTML = profileCard(person, {
        note: hasSpecificMatch
          ? "Reviso los criterios principales de esta formula: ingredientes, dosis y forma quimica."
          : "Integra el comite que revisa el enfoque de calidad, transparencia y formulacion responsable de VidaLabs."
      });
    }
  }

  function renderCart(root, people) {
    var selected = pickPeople(people, 3, "");
    var person = selected[0];
    var media = root.querySelector("[data-vl-proof-cart-media]");
    var title = root.querySelector("[data-vl-proof-cart-title]");
    var copy = root.querySelector("[data-vl-proof-cart-copy]");
    var details = root.querySelector("[data-vl-proof-cart-details]");

    if (media) media.innerHTML = avatar(person);
    if (title) title.textContent = "¿Sabías que tus productos pasan por revision profesional?";
    if (copy) {
      copy.textContent = "Profesionales como " + person.name + " forman parte del comite que revisa el enfoque cientifico y responsable de VidaLabs.";
    }
    if (details) {
      details.innerHTML = [
        "<p>El comite revisa criterios como ingredientes, dosis, forma quimica y claridad de comunicacion. Esta no es una consulta medica personalizada.</p>",
        '<div class="vl-proof__avatar-stack">',
        selected.map(function (item) { return avatar(item); }).join(""),
        '<span class="vl-proof__avatar-stack-text">' + people.length + ' profesionales registrados</span>',
        "</div>"
      ].join("");
    }
  }

  function renderProcess(root, people) {
    var selected = pickPeople(people, Number(root.dataset.count || 3), "");
    var grid = root.querySelector("[data-vl-proof-grid]");
    var total = root.querySelector("[data-vl-proof-count]");

    if (total) total.textContent = people.length || selected.length;
    if (grid) {
      grid.innerHTML = selected.map(function (person) {
        return profileCard(person, {
          note: "Participa en la construccion de un estandar mas claro, verificable y responsable para nuestros suplementos."
        });
      }).join("");
    }
  }

  function renderStrip(root, people) {
    var selected = pickPeople(people, Number(root.dataset.count || 3), root.dataset.productHandle);
    var avatars = root.querySelector("[data-vl-proof-avatars]");
    var count = root.querySelector("[data-vl-proof-count]");
    if (count) count.textContent = people.length || selected.length;
    if (avatars) {
      avatars.innerHTML = selected.map(function (person) {
        return avatar(person);
      }).join("");
    }
  }

  function render(root, people) {
    var variant = root.dataset.variant || "home";

    if (!people.length) {
      root.classList.add("is-error");
      var empty = root.querySelector("[data-vl-proof-empty]");
      if (empty) empty.hidden = false;
      return;
    }

    if (variant === "product") renderProduct(root, people);
    else if (variant === "cart") renderCart(root, people);
    else if (variant === "process") renderProcess(root, people);
    else if (variant === "strip") renderStrip(root, people);
    else renderHome(root, people);

    root.classList.remove("is-loading");
    root.classList.add("is-ready");
  }

  function hydrate(root) {
    if (!root || root.dataset.vlProofReady === "true") return;
    root.dataset.vlProofReady = "true";
    root.classList.add("is-loading");

    loadPeople(root.dataset.source)
      .then(function (people) {
        render(root, people);
      })
      .catch(function () {
        root.classList.remove("is-loading");
        root.classList.add("is-error");
        var loading = root.querySelector(".vl-proof__loading");
        if (loading) {
          loading.textContent = "No pudimos cargar el registro de profesionales en este momento.";
        }
      });
  }

  function scan() {
    document.querySelectorAll("[data-vl-proof]").forEach(hydrate);
  }

  window.VidaLabsHealthProof = {
    version: VERSION,
    scan: scan
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
})();
